import { Navigate, createFileRoute, useRouterState } from "@tanstack/react-router";
import { useAuth } from "../../lib/auth-context.js";
import { AppShell } from "../../components/app-shell.js";

/**
 * Layout for protected routes. Anon → /login. When activeIgAccount is null
 * AND the requested route is per-IG, redirect to /dashboard (which renders
 * the connect-Instagram empty state).
 */
export const Route = createFileRoute("/_app")({
  component: AppLayout,
});

// Workspace-level routes that should NOT redirect when no IG is connected.
const WORKSPACE_ALLOWLIST = [
  "/dashboard",
  "/settings",
  "/onboarding",
  "/invites",
];

function isWorkspaceRoute(pathname: string): boolean {
  return WORKSPACE_ALLOWLIST.some((p) => pathname.startsWith(p));
}

function AppLayout() {
  const { status, activeIgAccount } = useAuth();
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  if (status === "loading") {
    return <main style={{ padding: 96, textAlign: "center" }}>Loading…</main>;
  }
  if (status === "anon") return <Navigate to="/login" />;

  if (!activeIgAccount && !isWorkspaceRoute(pathname)) {
    return <Navigate to="/dashboard" />;
  }

  return <AppShell />;
}
